module.exports = __webpack_public_path__ + "static/img/money-01.47b4ae7.png";